import { Button, Flex, Icon } from '@chakra-ui/react'
import { GiftIcon } from '@heroicons/react/24/outline'
import { useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'
import Banner from '../../../common/components/Banner'
import { REFERRAL_REWARD_DAYS } from '../../../referral/scenes/Referrals/constants'
import { trackEvent } from '../../../../../services/analytics'
import messages from './messages'

/**
 * Dashboard promotion for the referral feature, alongside the sidebar entry —
 * the page itself is one more click away than the doctor's daily work, so the
 * reward is worth naming where they already are.
 */
export default function ReferralBanner() {
  const { formatMessage } = useIntl()
  const navigate = useNavigate()

  return (
    <Banner
      media={
        <Flex
          w="40px"
          h="40px"
          flex="0 0 auto"
          align="center"
          justify="center"
          alignSelf="center"
          borderRadius="10px"
          bg="gray.100"
        >
          <Icon as={GiftIcon} boxSize="20px" color="gray.700" />
        </Flex>
      }
      title={formatMessage(messages.title)}
      description={formatMessage(messages.description, {
        days: REFERRAL_REWARD_DAYS
      })}
      action={
        <Button
          size="md"
          onClick={() => {
            trackEvent('referral_banner_clicked')
            navigate('/referrals')
          }}
        >
          {formatMessage(messages.cta)}
        </Button>
      }
    />
  )
}
